import { orderBusiness } from "api/bussiness/order/order-bussiness";
import { productBussiness } from "api/bussiness/product/product-bussiness";
import { utcToLocal } from "commons/ultilities/date/dayjs";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { IProductProperties } from "mobx-stores/_models/products/product";
import { IAddEditWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useState } from "react";

export const useParchaseOrderItemValueChanged = ({
  getControl,
}: {
  getControl: (fieldName: keyof IAddEditWorkOrderPo) => IControl;
}) => {
  const { setProp: setStoreProp } = useStores();
  const [selectedProduct, setSelectedProduct] =
    useState<IProductProperties | null>(null);
  const onPurchaseOrderItemIdChanged = useCallback(
    async (value: string) => {
      try {
        setStoreProp("appFreeze", true);
        const purchaseOrderId = getControl("purchaseOrderId")?.value;
        if (!purchaseOrderId) return;
        const res = await orderBusiness.getById(purchaseOrderId);
        const purchaseOrderItem = res?.items?.find((x) => x.id === value);
        if (!purchaseOrderItem || !purchaseOrderItem.productId) return;
        const productDetail = await productBussiness.getById(
          purchaseOrderItem.productId,
        );

        setSelectedProduct(productDetail);

        getControl("productNameReadOnlyInfo")?.setValueAndValidate(
          productDetail?.name ?? "",
        );

        getControl("productCodeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.code ?? "",
        );

        getControl("productBarcodeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.barcode ?? "",
        );

        getControl("orderAmountReadOnlyInfo")?.setValueAndValidate(
          purchaseOrderItem.quantityStandard ?? "",
        );

        getControl("orderAmountUpperReadOnlyInfo")?.setValueAndValidate(
          purchaseOrderItem.quantityUpper ?? "",
        );

        getControl("orderAmountLowerReadOnlyInfo")?.setValueAndValidate(
          purchaseOrderItem.quantityLower ?? "",
        );

        getControl("paperTypeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.material?.paperType ?? "",
        );

        getControl("gsmReadOnlyInfo")?.setValueAndValidate(
          productDetail?.material?.gsmStandard ?? "",
        );

        getControl("paperBrandReadOnlyInfo")?.setValueAndValidate(
          productDetail?.material?.paperBrand ?? "",
        );

        getControl("firstFullPaperLengthReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.firstFullPaperLength ?? "",
        );

        getControl("firstFullPaperSizeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.firstFullPaperSize ?? "",
        );

        getControl("secondFullPaperLengthReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.secondFullPaperLength ?? "",
        );

        getControl("secondFullPaperSizeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.secondFullPaperSize ?? "",
        );

        getControl("firstPrintPaperLengthReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.printPaperLength ?? "",
        );

        getControl("firstPrintPaperSizeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.printPaperSize ?? "",
        );

        getControl("secondPrintPaperLengthReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.secondPrintPaperLength ?? "",
        );
        getControl("secondPrintPaperSizeReadOnlyInfo")?.setValueAndValidate(
          productDetail?.process?.secondPrintPaperSize ?? "",
        );
        getControl("deliveryDateReadOnlyInfo")?.setValueAndValidate(
          purchaseOrderItem?.deliveryDate
            ? utcToLocal(purchaseOrderItem.deliveryDate)
            : "",
        );
        return productDetail;
      } finally {
        setStoreProp("appFreeze", false);
      }
    },
    [getControl, setStoreProp],
  );
  return {
    onPurchaseOrderItemIdChanged,
    selectedProduct,
  };
};
